export default "__VITE_ASSET__DOEhisqu__"